import React from 'react';

import cn from 'classnames';

import { TPaymentMethod } from '@entities/widget-shop/model/types';
import { Flex, UiText } from '@shared/ui';

import cls from './PaymentMethodItem.module.css';

export const PaymentMethodItem = ({
    name,
    onMethodPick,
    activePaymentMethodType,
    icon,
    activeIcon,
    type,
    redirectLink,
}: Partial<TPaymentMethod> & {
    activePaymentMethodType: TPaymentMethod['type'];
    onMethodPick: () => void;
}) => {
    const isCurrentlyActive = activePaymentMethodType === type;
    const methodIcon = isCurrentlyActive ? activeIcon : icon;
    return (
        <li
            className={cn(cls.periodItem, isCurrentlyActive && cls.isActive)}
            onClick={onMethodPick}
        >
            <Flex wrap="wrap" gap={4} align="center" justify="center">
                <img src={methodIcon} alt="payment icon" width={20} height={20} />
                <UiText tag="span" variant="caption" align="center">
                    {name}
                </UiText>
            </Flex>
        </li>
    );
};
